import { normalizeScalePlu } from '@shared/barcode';
import { listCatalogProducts } from '../../catalog/public-api';
import { shareOrDownloadCsv } from '../../shared/csv-core/infra/shareCsv';
import {
  buildLabelScaleExportFile,
  type LabelScaleAdapterId,
  type LabelScaleExportRow,
} from '../domain/labelScaleExport';

function isWeightProduct(unit: string | undefined, sellByWeight: boolean | undefined): boolean {
  if (sellByWeight === true) return true;
  return unit === 'kg' || unit === 'g';
}

export type LabelScaleExportResult =
  | { ok: true; count: number; filename: string }
  | { ok: false; error: string };

/**
 * Lista productos pesables activos, arma PLU (SKU 5 dígitos) + $/kg, y descarga/comparte el archivo.
 */
export async function exportLabelScalePlu(
  adapterId: LabelScaleAdapterId,
): Promise<LabelScaleExportResult> {
  const products = await listCatalogProducts({
    status: 'active',
    itemType: 'all',
    limit: 50_000,
    offset: 0,
  });

  const rows: LabelScaleExportRow[] = [];
  for (const p of products) {
    if (!isWeightProduct(p.unitOfMeasure, p.sellByWeight)) continue;
    const sku = (p.sku ?? '').trim();
    if (!sku) continue;
    const plu = normalizeScalePlu(sku);
    if (!/^\d{5}$/.test(plu)) continue;
    const price = Number(p.price);
    if (!Number.isFinite(price) || price < 0) continue;
    rows.push({
      plu,
      name: (p.name ?? '').trim() || plu,
      price,
      type: 'P',
      department: '1',
    });
  }

  if (rows.length === 0) {
    return {
      ok: false,
      error: 'No hay productos pesables con PLU de 5 dígitos. Poné el SKU en 5 números (ej. 00011).',
    };
  }

  const { content, filename } = buildLabelScaleExportFile(adapterId, rows);
  await shareOrDownloadCsv(content, filename);
  return { ok: true, count: rows.length, filename };
}
